import service from "../providers/service.js";
import BrowserHistory from "../providers/BrowserHistory.js";
import { tokenize } from "../helpers/token.js";
import { SET_LETTERS, SET_SELECTED_LETTER } from "./types.js";
import { setErrors } from "./error.js";

// Fetch all letters
export function fetchLetters() {
  return (dispatch, getState) => {
    service
      .get(tokenize(`/api/letters`))
      .then(response => {
        // Save letters to redux store
        dispatch(setLetters(response.data.letters));
      }).catch((err) => {
        console.log(err);
      })
  }
}

// Fetch letter by id
export function fetchLetter(letterId) {
  return (dispatch) => {
    service
      .get(tokenize(`/api/letters/${letterId}`))
      .then(response => {
        // Save projects to redux store
        dispatch(setSelectedLetter(response.data.letter));
      }).catch((err) => {
        console.log(err);
      })
  }
}

// Create new letter
export function createLetter(letter) {
  return dispatch => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const data = new FormData();

    Object.keys(letter).forEach(k => {
      if (letter[k]) {
        if (letter[k].constructor === Array) {
          data.append(k, JSON.stringify(letter[k]));
        } else {
          data.append(k, letter[k]);
        }
      }
    });

    service
      .post(tokenize(`/api/letters`), data, config)
      .then(response => {
        if (response.data.message === 'letters.success') {
          dispatch(fetchLetters());
          BrowserHistory.push('/main/letters');
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// Update letter
export function updateLetter(letter) {
  return dispatch => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const data = new FormData();

    Object.keys(letter).forEach(k => {
      if (letter[k]) {
        if (letter[k].constructor === Array) {
          data.append(k, JSON.stringify(letter[k]));
        } else {
          data.append(k, letter[k]);
        }
      }
    });

    service
      .post(tokenize(`/api/letters/${letter.id}`), data, config)
      .then(response => {
        if (response.data.message === 'letters.success') {
          dispatch(fetchLetters());
          BrowserHistory.push('/main/letters');
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  };
}

// Delete letters
export function deleteLetter(letterId) {
  return dispatch => {
    service
      .post(tokenize(`/api/letters/${letterId}/destroy`))
      .then(response => {
        if (response.data.message === 'letters.success') {
          dispatch(fetchLetters());
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// set letters to store
export function setLetters(letters) {
  return {
    type: SET_LETTERS,
    letters: letters
  };
}

export function setSelectedLetter(letter) {
  return {
    type: SET_SELECTED_LETTER,
    letter: letter
  };
}


// WEBPACK FOOTER //
// ./src/actions/letter.js